import { List, Record } from 'immutable';
import { RoomCommissionSummary } from './room-commission-summary';
import { AdjustmentSummary } from './adjustment-summary';
import { PrepaymentSummary } from './prepayment-summary';
import { PaymentStatus } from '../payment-status.enum';

const PaymentSummaryRecord = Record({
  eventPartyId: null,
  roomCommissionSummary: null,
  adjustmentSummaryList: null,
  modifierSummaryList: null,
  prepayment: null,
  estimatedTax: null,
  calculatedPayment: null,
  paymentStatus: null,
  commissionAmount: null,
});

export class PaymentSummary extends PaymentSummaryRecord {
  eventPartyId: number;
  roomCommissionSummary: RoomCommissionSummary;
  adjustmentSummaryList: List<AdjustmentSummary>;
  modifierSummaryList: List<AdjustmentSummary>;
  prepayment: PrepaymentSummary;
  estimatedTax: number;
  calculatedPayment: number;
  paymentStatus: PaymentStatus;
  commissionAmount: number;
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/payment-summary.ts